// App Imports
import {
  ACCOUNT_OBJECT_RESET,
  GET_ACCOUNT_BALANCE_REQUEST,
  GET_ACCOUNT_BALANCE_RESPONSE,
  GET_ACCOUNT_LEDGER_FAILURE,
  GET_ACCOUNT_LEDGER_REQUEST,
  GET_ACCOUNT_LEDGER_RESPONSE,
  GET_ACCOUNT_REQUEST,
  GET_ACCOUNT_RESPONSE,
  HYDRATE_ACCOUNT_REQUEST,
  HYDRATE_ACCOUNT_RESPONSE,
  METER_HISTORY_LOOKUP_REQUEST,
  METER_HISTORY_LOOKUP_RESPONSE,
  REFRESH_CLIENT_ACCOUNT_BALANCE,
  RESET_METER_ACCOUNT_READINGS,
  UPDATE_ACCOUNT_NOTES_ARRAY,
  UPDATE_ACCOUNT_REQUEST,
  UPDATE_ACCOUNT_RESPONSE,
  UPDATE_CLIENT_ACCOUNT_LEDGER,
  UPDATE_CLIENT_ACCOUNT_OBJECT,
  UPDATE_LOOKED_UP_METER,
  CREATE_ADDRESS_REQUEST,
  CREATE_ADDRESS_RESPONSE,
  CREATE_ADDRESS_FAILURE,
  UPDATE_ADDRESS_REQUEST,
  UPDATE_ADDRESS_RESPONSE,
  UPDATE_ADDRESS_FAILURE,
  DELETE_ADDRESS_REQUEST,
  DELETE_ADDRESS_RESPONSE,
  DELETE_ADDRESS_FAILURE,
  GET_ACCOUNT_BY_ACCTNUM_REQ,
  GET_ACCOUNT_BY_ACCTNUM_RESP,
  GET_ACCOUNT_BY_ACCTNUM_FAILURE,
  DELETE_ACCOUNT_REQUEST,
  DELETE_ACCOUNT_RESPONSE,
  DELETE_ACCOUNT_FAILURE,
  UPDATE_ACCOUNT_DISCOUNT_REQUEST,
  UPDATE_ACCOUNT_DISCOUNT_RESPONSE,
  UPDATE_ACCOUNT_DISCOUNT_FAILURE,
  GET_WINTER_CRISIS_HISTORY_REQUEST,
  GET_WINTER_CRISIS_HISTORY_RESPONSE,
  GET_WINTER_CRISIS_HISTORY_FAILURE,
  CREATE_WINTER_CRISIS_HISTORY_REQUEST,
  CREATE_WINTER_CRISIS_HISTORY_RESPONSE,
  CREATE_WINTER_CRISIS_HISTORY_FAILURE,
  CHECK_WINTER_CRISIS_AVAILABILITY_REQUEST,
  CHECK_WINTER_CRISIS_AVAILABILITY_RESPONSE,
  CHECK_WINTER_CRISIS_AVAILABILITY_FAILURE,
  GET_MED_FORM_HISTORY_REQUEST,
  GET_MED_FORM_HISTORY_RESPONSE,
  GET_MED_FORM_HISTORY_FAILURE,
  DELETE_MED_FORM_HISTORY_REQUEST,
  DELETE_MED_FORM_HISTORY_RESPONSE,
  DELETE_MED_FORM_HISTORY_FAILURE,
  GET_PLEDGE_HISTORY_REQUEST,
  GET_PLEDGE_HISTORY_RESPONSE,
  GET_PLEDGE_HISTORY_FAILURE,
  UPDATE_PLEDGE_HISTORY_REQUEST,
  UPDATE_PLEDGE_HISTORY_RESPONSE,
  UPDATE_PLEDGE_HISTORY_FAILURE,
  CREATE_PLEDGE_HISTORY_REQUEST,
  CREATE_PLEDGE_HISTORY_RESPONSE,
  CREATE_PLEDGE_HISTORY_FAILURE,
  DELETE_PLEDGE_HISTORY_REQUEST,
  DELETE_PLEDGE_HISTORY_RESPONSE,
  DELETE_PLEDGE_HISTORY_FAILURE,
} from "./actions";
const today = new Date();
// Initial State
const accountsInitialState = {
  isLoading: true,
  error: null,
  data: {},
  // Keeps it apart of account but segregates it to its own loading state
  ledgerIsLoading: true,
  isPledgeLoading: false,
  ledgerError: null,
  ledger: {},
  meterLookupIsLoading: true,
  meterReads: [],
  meterLookupError: null,
  isInitialAccountLoading: false,
  initialAccount: null,
  winterCrisisHistory: {
    items: [],
    toDelete: [],
    toUpdate: [],
  },
  winterCrisisAvailability: {
    available: false,
    isActive: false,
    isLoading: false,
    error: null,
  },
  medFormHistory: {
    items: [],
    toDelete: [],
    toUpdate: [],
  },
  pledges: {
    items: [],
    toDelete: [],
    toUpdate: [],
  },
  newForwardingAddress:
  {
    addressType: "Forwarding",
    //effectiveDate: today,
    address1: "",
    address2: "",
    city: "",
    zip: "",
    state: "",
  },
  newAddress:
  {
    addressType: "Billing",
    //effectiveDate: today,
    address1: "",
    address2: "",
    city: "",
    zip: "",
    state: "",
  }
};

// State
export default (state = accountsInitialState, action) => {
  switch (action.type) {
    case ACCOUNT_OBJECT_RESET:
      return Object.assign({}, accountsInitialState);
    case UPDATE_CLIENT_ACCOUNT_OBJECT:
      var newStateData = state.data;
      newStateData = action.newAccountObject;
      return {
        ...state,
        data: newStateData,
      };
    case METER_HISTORY_LOOKUP_REQUEST:
      return {
        ...state,
        meterLookupError: null,
        meterLookupIsLoading: true,
      };
    case RESET_METER_ACCOUNT_READINGS:
      return {
        ...state,
        meterReads: [],
        data:
          state.data && typeof state.data === "object"
            ? { ...state.data, meterReads: [] }
            : state.data,
      };
    case UPDATE_LOOKED_UP_METER: {
      const batch = Array.isArray(action.newMeterHistory) ? action.newMeterHistory : [];
      const targetMeterId = action.meterId ?? batch[0]?.meterId;
      const baseReads =
        targetMeterId != null && targetMeterId !== ""
          ? state.meterReads.filter((r) => String(r.meterId) !== String(targetMeterId))
          : state.meterReads;
      const merged = [...baseReads, ...batch];
      const sortedMeterReads = merged.sort(
        (a, b) => new Date(b.readDate) - new Date(a.readDate)
      );
      let nextData = state.data && typeof state.data === "object" ? { ...state.data } : state.data;
      if (nextData?.unit?.meters?.length && targetMeterId != null && targetMeterId !== "") {
        nextData = {
          ...nextData,
          unit: {
            ...nextData.unit,
            meters: nextData.unit.meters.map((m) =>
              m.id == targetMeterId ? { ...m, readCount: batch.length } : m
            ),
          },
          meterReads: sortedMeterReads,
        };
      } else if (nextData && typeof nextData === "object") {
        nextData = { ...nextData, meterReads: sortedMeterReads };
      }
      return {
        ...state,
        meterReads: sortedMeterReads,
        data: nextData,
      };
    }
    case METER_HISTORY_LOOKUP_RESPONSE:
      return {
        ...state,
        meterLookupError: action.error,
        meterLookupIsLoading: false,
      };
    case UPDATE_ACCOUNT_NOTES_ARRAY:
      //Sorts initial ledger by transaction date
      state.data.notes = action.error;
      const updatedData = state.data;
      return {
        ...state,
        data: updatedData,
      };
    case UPDATE_CLIENT_ACCOUNT_LEDGER:
      //Sorts initial ledger by transaction date
      const sortedLedger = action.newAccountLedger.entries
        .slice()
        .sort(
          (a, b) => new Date(b.transactionDate) - new Date(a.transactionDate)
        );
      action.newAccountLedger.entries = sortedLedger;
      return {
        ...state,
        ledger: action.newAccountLedger,
      };
    case CREATE_ADDRESS_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case CREATE_ADDRESS_RESPONSE:
      if (action.response.id) {
        if (action.response.addressType == "Billing") {
          state.data.addresses[0] = action.response;
        }
        else {
          state.data.forwardingAddress[0] = action.response;
        }
      }
      return {
        ...state,
        error: null,
        data: state.data,
        isLoading: false,
      };
    case CREATE_ADDRESS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case GET_ACCOUNT_BY_ACCTNUM_REQ:
      return {
        ...state,
        error: null,
        isInitialAccountLoading: action.isLoading,
      };
    case GET_ACCOUNT_BY_ACCTNUM_RESP:
      var newInitialAccount = null;
      if (action.response && action.response.length > 0) {
        newInitialAccount = action.response[0];
      }
      return {
        ...state,
        isInitialAccountLoading: false,
        initialAccount: newInitialAccount
      };
    case GET_ACCOUNT_BY_ACCTNUM_FAILURE:
      return {
        ...state,
        error: action.error,
        isInitialAccountLoading: false,
      };
    case UPDATE_ADDRESS_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case UPDATE_ADDRESS_RESPONSE:
      if (action.response.id) {
        if (action.response.addressType == "Billing") {
          state.data.addresses[0] = action.response;
        }
        else {
          state.data.forwardingAddress[0] = action.response;
        }
      }
      return {
        ...state,
        error: null,
        data: state.data,
        isLoading: false,
      };
    case UPDATE_ADDRESS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case GET_ACCOUNT_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_ACCOUNT_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case GET_ACCOUNT_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_ACCOUNT_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case DELETE_ADDRESS_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case DELETE_ADDRESS_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case DELETE_ADDRESS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case GET_ACCOUNT_LEDGER_REQUEST:
      return {
        ...state,
        ledgerError: null,
        ledgerIsLoading: action.ledgerIsLoading,
      };
    case GET_ACCOUNT_LEDGER_RESPONSE:
      return {
        ...state,
        ledgerError: action.ledgerError,
        ledgerIsLoading: false,
      };
    case GET_ACCOUNT_LEDGER_FAILURE:
      return {
        ...state,
        ledgerError: action.ledgerError,
        ledgerIsLoading: false,
      };
    case REFRESH_CLIENT_ACCOUNT_BALANCE:
      state.data.ongoingAccountBalance = action.newBalanceObject;
      return {
        ...state,
        data: state.data,
      };
    case GET_ACCOUNT_BALANCE_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_ACCOUNT_BALANCE_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case HYDRATE_ACCOUNT_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case HYDRATE_ACCOUNT_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case HYDRATE_ACCOUNT_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case UPDATE_ACCOUNT_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case UPDATE_ACCOUNT_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case DELETE_ACCOUNT_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case DELETE_ACCOUNT_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case UPDATE_ACCOUNT_DISCOUNT_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case UPDATE_ACCOUNT_DISCOUNT_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case UPDATE_ACCOUNT_DISCOUNT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };  
    case GET_WINTER_CRISIS_HISTORY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_WINTER_CRISIS_HISTORY_RESPONSE:
        state.winterCrisisHistory.items = [];
        console.log("winter crisis history",action.winterCrisisHistory);
         action.winterCrisisHistory.map((item) => {
          console.log("winter crisis history item",item);
          state.winterCrisisHistory.items.push(item);
         });
      return {
        ...state,
        winterCrisisHistory : state.winterCrisisHistory,
        isLoading: false,
      };
    case GET_WINTER_CRISIS_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case CREATE_WINTER_CRISIS_HISTORY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case CREATE_WINTER_CRISIS_HISTORY_RESPONSE:
      if (action.winterCrisisHistory) {
        // Add the new winter crisis history to the items array
        if (!state.winterCrisisHistory.items) {
          state.winterCrisisHistory.items = [];
        }
        // Handle both single object and array responses
        const newHistory = Array.isArray(action.winterCrisisHistory) 
          ? action.winterCrisisHistory 
          : [action.winterCrisisHistory];
        state.winterCrisisHistory.items = [...state.winterCrisisHistory.items, ...newHistory];
        // Update account winterCrisis flag to true (backend should handle this, but update state for consistency)
        if (state.data.account) {
          state.data.account.winterCrisis = 1;
        }
      }
      return {
        ...state,
        error: action.error || null,
        isLoading: false,
        winterCrisisHistory: state.winterCrisisHistory,
        data: state.data,
      };
    case CREATE_WINTER_CRISIS_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case CHECK_WINTER_CRISIS_AVAILABILITY_REQUEST:
      return {
        ...state,
        winterCrisisAvailability: {
          ...state.winterCrisisAvailability,
          isLoading: true,
          error: null,
        },
      };
    case CHECK_WINTER_CRISIS_AVAILABILITY_RESPONSE:
      return {
        ...state,
        winterCrisisAvailability: {
          available: action.winterCrisisAvailable || false,
          isActive: action.isActive || false,
          isLoading: false,
          error: action.error || null,
        },
      };
    case CHECK_WINTER_CRISIS_AVAILABILITY_FAILURE:
      return {
        ...state,
        winterCrisisAvailability: {
          ...state.winterCrisisAvailability,
          isLoading: false,
          error: action.error,
        },
      };
    case GET_MED_FORM_HISTORY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_MED_FORM_HISTORY_RESPONSE:
        state.medFormHistory.items = [];
        console.log("med form history",action.medFormHistory);
         action.medFormHistory.map((item) => {
          console.log("med form history item",item);
          state.medFormHistory.items.push(item);
         });
      return {
        ...state,
        medFormHistory : state.medFormHistory,
        isLoading: false,
      };
    case GET_MED_FORM_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case DELETE_MED_FORM_HISTORY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case DELETE_MED_FORM_HISTORY_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: action.error || null,
      };
    case DELETE_MED_FORM_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case GET_PLEDGE_HISTORY_REQUEST:
      return {
        ...state,
        error: null,
        pledgeIsLoading: action.isLoading,
      };
    case GET_PLEDGE_HISTORY_RESPONSE:
      return {
        ...state,
        pledges: {
          ...state.pledges,
          items: action.response,
          error: null,
          pledgeIsLoading: false
        },
      };
    case GET_PLEDGE_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case CREATE_PLEDGE_HISTORY_REQUEST:
      return {
        ...state,
        error: null,
        pledgeIsLoading: action.isLoading,
      };
    case CREATE_PLEDGE_HISTORY_RESPONSE:
      return {
        ...state,
        pledges: {
          ...state.pledges,
          items: state.pledges.items.map(item =>
            item.id === action.response.id ? action.response : item
          ),
          error: null,
          pledgeIsLoading: false,
        },
      };
    case CREATE_PLEDGE_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
        pledgeIsLoading: false,
      };
    case UPDATE_PLEDGE_HISTORY_REQUEST:
      return {
        ...state,
        error: null,
        pledgeIsLoading: action.isLoading,
      };
    case UPDATE_PLEDGE_HISTORY_RESPONSE:
      return {
        ...state,
        pledges: {
          ...state.pledges,
          items: state.pledges.items.map(item =>
            item.id === action.response.id ? action.response : item
          ),
          error: null,
          pledgeIsLoading: false,
        },
      };
    case UPDATE_PLEDGE_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
        pledgeIsLoading: false,
      };
    case DELETE_PLEDGE_HISTORY_REQUEST:
      return {
        ...state,
        error: null,
        pledgeIsLoading: action.isLoading,
      };
    case DELETE_PLEDGE_HISTORY_RESPONSE:
      return {
        ...state,
        pledges: {
          ...state.pledges,
          items: action.response,
          error: null,
          pledgeIsLoading: false,
        },
      };
    case DELETE_PLEDGE_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
        pledgeIsLoading: false,
      };


    default:
      return {
        ...state,
      };
  }
};
